import { onUnmounted, getCurrentInstance } from 'vue';

/**
 * Call onUnmounted() if it's inside a component lifecycle, if not, do nothing
 *
 * @param {Function} fn
 */
export default function tryOnUnMounted(fn) {
  // TODO: remove this try catch after removing vue2 stack
  try {
    if (getCurrentInstance()) {
      onUnmounted(fn);
    }
  } catch (e) {
    // no need to console the error
  }
}
